<template>
    <div v-redirect-if-no-permission:REGISTERED_CAPTAINS>
        <loading-component :value="loading"/>
        <v-tabs grow color="secondary" dark icons-and-text>
            <v-tabs-slider color="accent"></v-tabs-slider>
            <v-tab href="#search">
                Search
                <v-icon color="white">search</v-icon>
            </v-tab>
            <v-tab href="#incomplete" v-if="hasPermission('INCOMPLETE_CAPTAINS')">
                Incomplete
                <v-icon color="white">fa fa-battery-half</v-icon>
            </v-tab>
            <v-tab href="#unapproved" v-if="hasPermission('APPROVE_CAPTAINS')">
                Not Approved
                <v-icon color="white">fa fa-meh-o</v-icon>
            </v-tab>
            <v-tab href="#approved">
                Approved
                <v-icon color="white">fa fa-smile-o</v-icon>
            </v-tab>
            <v-tab v-if="hasPermission('UN_BLACKLIST_CAPTAIN')" href="#blacklisted">
                Blacklisted
                <v-icon color="white">block</v-icon>
            </v-tab>
            <v-tab href="#archived">
                Archived
                <v-icon color="white">fa fa-frown-o</v-icon>
            </v-tab>
            <v-tab href="#new_acq">
                New Acq
                <v-icon color="white">assignment</v-icon>
            </v-tab>
            <v-tab href="#lost-incomplete" v-if="hasPermission('LOST_INCOMPLETE_CAPTAINS')">
                Lost Incomplete
                <v-icon color="white">fa fa-reply</v-icon>
            </v-tab>
            <v-tab-item value="search">
                <search provider="captains"></search>
            </v-tab-item>

            <v-tab-item value="incomplete" lazy v-if="hasPermission('INCOMPLETE_CAPTAINS')">
                <DataTable :url="api.ACTIONS.CAPTAINS"
                           ref="incomplete"
                           :initial-url-search-params="params('incomplete')"
                           :actions-extra-main="actionsExtra('incomplete')"
                           :enable-edit="false"
                           :enable-add="false"
                           :enable-delete="false"
                           :fields-hidden-main="['no_conviction', 'email','updated_at', 'whatsapp_number',
                           'location_id', 'gender','driving_certificate_start_date',
                           'blacklisted_at','blacklist_note',
                           'approved_at',
                           'driving_certificate_end_date','only_female','finger_print','car','cars',
                           'nationality_id','bank_id','profile_image','delete_note',
                           'wallet','active','deleted_at','birthday','id_card_front','id_card_back','driving_certificate_front','driving_certificate_back',
                           'auto_accept','can_see_booking_price','can_change_auto_accept','only_accepts_bookings_from_suggestions',
                           'end_ride'
                           ]"
                           :titles="titles"
                />
            </v-tab-item>
            <v-tab-item value="unapproved" lazy v-if="hasPermission('APPROVE_CAPTAINS')">
                <DataTable :url="api.ACTIONS.CAPTAINS"
                           ref="unapproved"
                           :initial-url-search-params="params('unapproved')"
                           :actions-extra-main="actionsExtra('unapproved')"
                           :enable-edit="false"
                           :enable-add="false"
                           :enable-delete="false"
                           :fields-hidden-main="['no_conviction', 'email','updated_at', 'whatsapp_number',
                           'location_id', 'gender','driving_certificate_start_date',
                           'end_ride','blacklist_note',
                           'blacklisted_at',
                           'approved_at',
                           'driving_certificate_end_date','only_female','finger_print','car','cars',
                           'nationality_id','bank_id','profile_image','delete_note',
                           'wallet','active','deleted_at','birthday','id_card_front','id_card_back','driving_certificate_front','driving_certificate_back']"
                           :titles="titles"
                />
            </v-tab-item>
            <v-tab-item value="approved" lazy>
                <DataTable :url="api.ACTIONS.CAPTAINS"
                           ref="approved"
                           :initial-url-search-params="params('approved')"
                           :actions-extra-main="actionsExtra('approved')"
                           :enable-edit="false"
                           :enable-delete="false"
                           :fields-hidden-main="['location_id','blacklist_note','end_ride','delete_note','blacklisted_at', 'car','cars','email', 'no_conviction', 'gender','driving_certificate_start_date','driving_certificate_end_date','only_female','finger_print','nationality_id','bank_id','profile_image','wallet','active','deleted_at','birthday','id_card_front','id_card_back','driving_certificate_front','driving_certificate_back','updated_at']"
                           :titles="titles"
                           :enable-add="false"/>
            </v-tab-item>
            <v-tab-item value="blacklisted" v-if="hasPermission('UN_BLACKLIST_CAPTAIN')" lazy>
                <DataTable :url="api.ACTIONS.CAPTAINS"
                           ref="blacklisted"
                           :initial-url-search-params="params('blacklisted')"
                           :actions-extra-main="actionsExtra('blacklisted')"
                           :enable-edit="false"
                           :enable-delete="false"
                           :fields-hidden-main="['location_id','blacklist_note','end_ride','delete_note', 'car','cars','email', 'no_conviction', 'gender','driving_certificate_start_date','driving_certificate_end_date','only_female','finger_print','nationality_id','bank_id','profile_image','wallet','active','deleted_at','birthday','id_card_front','id_card_back','driving_certificate_front','driving_certificate_back','updated_at']"
                           :titles="titles"
                           :enable-add="false"/>
            </v-tab-item>
            <v-tab-item value="archived" lazy>
                <DataTable :url="api.ACTIONS.CAPTAINS"
                           ref="archived"
                           :initial-url-search-params="params('archived')"
                           :actions-extra-main="actionsExtra('archived')"
                           :enable-edit="false"
                           :titles="titles"
                           :enable-delete="false"
                           :formatter="formatter"
                           :fields-hidden-main="['id_card_front','blacklist_note','end_ride','delete_note','id_card_back','driving_certificate_front','driving_certificate_back',
                           'location_id','car','cars', 'email', 'no_conviction', 'gender','driving_certificate_start_date','driving_certificate_end_date','only_female','finger_print','nationality_id','bank_id','profile_image','wallet','active','deleted_at','birthday','id_card','updated_at']"
                           :enable-add="false"/>
            </v-tab-item>
            <v-tab-item value="new_acq" lazy>
                <DataTable url="captain_registration_request" ref="new_acq"
                           :enable-edit="false" :enable-delete="false" :enable-add="false"
                           :actions-extra-main="actionsExtra('new_acq')" :formatter="newCaqFormatter"
                           :fields-hidden-main="['registration_request_id', 'updated_at']"/>
            </v-tab-item>
            <v-tab-item value="lost-incomplete" lazy v-if="hasPermission('LOST_INCOMPLETE_CAPTAINS')">
                <DataTable :url="api.ACTIONS.CAPTAINS"
                           ref="lost_incomplete"
                           :initial-url-search-params="params('lost-incomplete')"
                           :actions-extra-main="actionsExtra('lost-incomplete')"
                           :enable-edit="false"
                           :enable-add="false"
                           :enable-delete="false"
                           :fields-hidden-main="['no_conviction', 'email','updated_at', 'whatsapp_number',
                           'location_id', 'gender','driving_certificate_start_date',
                           'blacklisted_at','blacklist_note',
                           'approved_at',
                           'driving_certificate_end_date','only_female','finger_print','car','cars',
                           'nationality_id','bank_id','profile_image','delete_note',
                           'wallet','active','deleted_at','birthday','id_card_front','id_card_back','driving_certificate_front','driving_certificate_back']"
                           :titles="titles"
                />
            </v-tab-item>
        </v-tabs>
        <confirm-captain-dialog @approved="updateUnapprovedTable" ref="confirm_dialog"
                                :settings.sync="confirm_dialog"></confirm-captain-dialog>
        <v-dialog v-model="create_interview.visible" lazy width="50%">
            <interview-creator :key="create_interview.visible" :captain="create_interview.captain"
                               :enable-change-captain="false"
                               :show-create-captain="false"
                               :action="create_interview.action"
                               :statuses="create_interview.statuses"
                               @saved="interviewCreated"/>
        </v-dialog>
        <v-dialog v-model="notesDialog.visible" width="50%">
            <v-card>
                <v-card-title primary-titly class="title font-weight-bold">
                    Enter a note
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-textarea v-model="notesDialog.note" label="Note"/>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="green" @click="notesDialog.createInterview">
                        Create Interview
                    </v-btn>
                    <v-btn color="red" @click="notesDialog.noContinue">
                        Doesn't want to continue
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog :value="enterPassword.show" @input="enterPassword.show = !enterPassword.show" width="50%">
            <v-card>
                <v-card-title primary class="title red white--text font-weight-bold">
                    Enter Your password
                </v-card-title>
                <v-divider/>
                <v-card-text class="px-4">
                    <v-label class="headline">
                        {{enterPassword.hint}}
                    </v-label>
                    <v-form ref="password_form">
                        <v-text-field :disabled="loading" type="password" v-model="enterPassword.password"
                                      label="Password" required/>
                        <v-text-field v-if="enterPassword.needsNote"
                                      :disabled="loading" v-model="enterPassword.note"
                                      label="Note" required/>
                    </v-form>
                    <v-flex xs4 offset-xs8>
                        <v-btn color="red" style="color: white;" @click="submitPasswordAction">
                            Do It
                        </v-btn>
                    </v-flex>
                </v-card-text>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import moment from "moment";
    import Search from "@/components/wasilni/SearchAgent";
    import ConfirmCaptainDialog from '@/components/wasilni/input/ConfirmCaptainDialog';
    import LoadingComponent from "@/components/LoadingComponent";
    import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";


    export default {
        name: "RegisteredCaptains",
        title: 'Captains',
        components: {InterviewCreator, LoadingComponent, DataTable, Search, ConfirmCaptainDialog},
        data() {
            return {
                loading: false,
                confirm_dialog: {
                    visible: false,
                    captain_id: null
                },
                enterPassword: {
                    show: false,
                    hint: null,
                    password: null,
                    action: null,
                    needsNote: false,
                    note: null
                },
                create_interview: {
                    visible: false,
                    captain: null,
                    statuses: [],
                    action: null
                },
                notesDialog: {
                    visible: false,
                    action: null,
                    note: "",
                    createInterview: () => {
                    },
                    noContinue: () => {
                    }
                }
            };
        },
        watch: {
            "enterPassword.show": function (val) {
                this.enterPassword.password = null;
                this.enterPassword.note = null;
            }
        },
        computed: {
            titles() {
                return {
                    created_at: "Creation Date",
                    id: "#",
                    email: "Email",
                    username: "Phone Number",
                    deleted_at: "Archiving Date",
                    active: "Was Approved",
                    first_name: "First Name",
                    last_name: "Last Name"
                };
            },
            formatter() {
                return {
                    active(val) {
                        //language=HTML
                        return `
                        <i class="v-icon fa ${val ? 'fa-check' : 'fa-close'}"></i>
                        `;
                    }
                }
            },
            newCaqFormatter() {
                return {
                    captain_id(val) {
                        return val ? val : 'No captain Entry'
                    }
                }
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.INTERVIEW_STATUS)
                .then(
                    async ({data: {data}}) => {
                        this.create_interview.statuses = data;
                        this.loading = false;

                    }
                )
                .catch(
                    () => this.loading = false
                )
        },
        methods: {
            interviewCreated() {
                window.getApp.$emit("SHOW_TOAST", "Saved interview for " + this.create_interview.captain.first_name + " " + this.create_interview.captain.last_name);
                this.create_interview.visible = false;
            },
            async submitPasswordAction() {
                if (!this.$refs.password_form.validate())
                    return;
                this.loading = true;
                try {
                    await this.enterPassword.action();
                    this.enterPassword.show = false;
                } catch (e) {
                } finally {
                    this.loading = false;
                }
            },
            updateUnapprovedTable(id) {
                this.$refs.unapproved.removeItemFromTable((item) => item.id !== id);

            },
            params(state) {
                return new URLSearchParams(`state=${state}`);
            },
            actionsExtra(state) {
                const didntAnswer = {
                    title: "Didnt Answer",
                    color: "red",
                    action: async item => {
                        try {
                            let data = {
                                answered: false,
                                interview: null,
                                note: "Didn't Answer"
                            };
                            if (item.username) {
                                data.captain_id = item.id;
                            } else {
                                data.captain_registration_request_id = item.id;
                            }
                            await this.axios.post(this.api.ACTIONS.INCOMPLETE_CAPTAIN, data);
                            window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                            this.$set(this.notesDialog, 'visible', false);
                            this.create_interview.visible = false;
                            this.$refs.incomplete && this.$refs.incomplete.removeItemFromTable(item);
                            this.$refs.new_acq && this.$refs.new_acq.removeItemFromTable(item);
                        } catch (e) {
                            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                        }
                    }
                };

                const answered = {
                    title: "Answered",
                    color: "green",
                    action: item => {
                        this.notesDialog = {
                            visible: true,
                            action: null,
                            note: "",
                            createInterview: async () => {
                                if (!this.notesDialog.note.length) {
                                    alert("Enter note");
                                    return;
                                }
                                this.notesDialog.visible = false;
                                this.create_interview = {
                                    visible: true,
                                    captain: item,
                                    statuses: this.create_interview.statuses,
                                    action: async interview => {
                                        interview.datetime = interview.date + ' ' + interview.time;
                                        try {
                                            let data = {
                                                answered: true,
                                                interview,
                                                note: this.notesDialog.note
                                            };
                                            if (item.username) {
                                                data.captain_id = item.id;
                                            } else {
                                                data.captain_registration_request_id = item.id;
                                            }
                                            await this.axios.post(this.api.ACTIONS.INCOMPLETE_CAPTAIN, data);
                                            window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                                            this.create_interview.visible = false;
                                            this.notesDialog.visible = false;
                                            this.$refs.incomplete && this.$refs.incomplete.removeItemFromTable(item);
                                            this.$refs.new_acq && this.$refs.new_acq.removeItemFromTable(item);
                                        } catch (e) {
                                            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                                        }
                                    }
                                };
                            },
                            noContinue: async () => {
                                if (!this.notesDialog.note.length) {
                                    alert("Enter Note");
                                    return;
                                }
                                try {
                                    await this.axios.post(this.api.ACTIONS.INCOMPLETE_CAPTAIN, {
                                        captain_id: item.id,
                                        answered: true,
                                        interview: null,
                                        note: this.notesDialog.note
                                    });
                                    this.notesDialog.visible = false;
                                    window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                                    this.$refs.incomplete && this.$refs.incomplete.removeItemFromTable(item);
                                } catch (e) {
                                    window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                                }
                            },

                        }
                    }
                }

                const createInterview = {
                    title: "Create Interview",
                    color: 'green',
                    action: (item) => {
                        this.create_interview = {
                            visible: true,
                            captain: item,
                            statuses: this.create_interview.statuses
                        };
                    }
                };

                const moveToApproved = {
                    title: "Activate",
                    icon: "thumb_up",
                    extras: {
                        color: 'green',
                        medium: true
                    },
                    action: async (item) => {
                        this.confirm_dialog = {
                            visible: true,
                            captain_id: item.id
                        };
                    }
                };
                const moveToArchive = {
                    title: "Delete",
                    icon: 'delete',
                    extras: {
                        medium: true
                    },
                    action: async (item) => {
                        this.enterPassword.action = async () => {
                            try {
                                const {data} = await this.axios.delete(this.api.ACTIONS.CAPTAINS + '/' + item.id, {
                                    data: {
                                        password: this.enterPassword.password,
                                        note: this.enterPassword.note
                                    }
                                });
                                window.getApp.$emit("SHOW_TOAST", "Archived", "green");
                                this.$refs.approved && this.$refs.approved.removeItemFromTable(item);
                                this.$refs.unapproved && this.$refs.unapproved.removeItemFromTable(item);
                                this.$refs.incomplete && this.$refs.incomplete.removeItemFromTable(item);
                                this.$refs.archived && this.$refs.archived.addItemToTable(Object.assign(item, {deleted_at: moment().format("YYYY-MM-DD HH:mm:ss")}));
                            } catch (e) {
                                window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                                throw e;
                            }
                        };
                        this.enterPassword.show = true;
                        this.enterPassword.hint = `You are about to Archive Captain ${item.first_name} ${item.last_name}`;
                        this.enterPassword.needsNote = true;
                        return {};
                    }
                };
                const unArchive = {
                    title: "Unarchive",
                    icon: "lock_open",
                    extras: {
                        color: "primary",
                        large: true,
                    },
                    action: async (item) => {
                        try {
                            const {data} = await this.axios.delete(this.api.ACTIONS.CAPTAINS + '/' + item.id);
                            window.getApp.$emit("SHOW_TOAST", `Moved to ${!!item.approved_at ? 'Approved' : 'Unapproved'}`, "green");
                            this.$refs.archived.removeItemFromTable(item);
                            item = data.data;
                            if (!!item.approved_at)
                                this.$refs.approved && this.$refs.approved.addItemToTable(item);
                            else
                                this.$refs.unapproved && this.$refs.unapproved.addItemToTable(item);
                        } catch (e) {
                            window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                            return {};
                        }
                    }
                };
                const goToProfile = {
                    title: "Go To Profile",
                    icon: "info",
                    extras: {
                        color: "secondary",
                        large: true,
                    },
                    action: async (item) =>
                        this.$router.push({
                            name: 'CaptainProfile',
                            params: item
                        })
                };
                const blacklist = {
                    title: "blacklist",
                    icon: "block",
                    extras: {
                        color: "red",
                        large: true,
                    },
                    action: (item) => {
                        this.enterPassword.action = async () => {
                            try {
                                const {data} = await this.axios.post(
                                    this.api.ACTIONS.CAPTAINS + '/' + item.id + '/blacklist',
                                    {password: this.enterPassword.password, note: this.enterPassword.note});
                                window.getApp.$emit("SHOW_TOAST", `Moved to Blacklisted`, "green");
                                this.$refs.approved && this.$refs.approved.removeItemFromTable(item);
                                this.$refs.unapproved && this.$refs.unapproved.removeItemFromTable(item);
                                this.$refs.blacklisted && this.$refs.blacklisted.addItemToTable(item);
                                return {};
                            } catch (e) {
                                console.log(e);
                                window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                                return {};
                            }
                        };
                        this.enterPassword.show = true;
                        this.enterPassword.hint = `You are about to blacklist Captain ${item.first_name} ${item.last_name}`;
                        this.enterPassword.needsNote = true;

                        return {};

                    }
                };
                const unBlacklist = {
                    title: "Unblacklist",
                    icon: "block",
                    extras: {
                        color: "green",
                        large: true,
                    },
                    action: async (item) => {
                        this.enterPassword.action = async () => {
                            try {
                                const {data} = await this.axios.post(this.api.ACTIONS.CAPTAINS + '/' + item.id + '/un_blacklist', {password: this.enterPassword.password});
                                window.getApp.$emit("SHOW_TOAST", `Moved to ${!!item.approved_at ? 'Approved' : 'Unapproved'}`, "green");
                                this.$refs.blacklisted.removeItemFromTable(item);

                                if (!!item.approved_at)
                                    this.$refs.approved && this.$refs.approved.addItemToTable(item);
                                else
                                    this.$refs.unapproved && this.$refs.unapproved.addItemToTable(item);
                                return {};

                            } catch (e) {
                                window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red");
                                return {};
                            }
                        };
                        this.enterPassword.hint = `You are about to unblacklist Captain ${item.first_name} ${item.last_name}`;
                        this.enterPassword.show = true;
                        this.enterPassword.needsNote = false;

                    }
                };
                switch (state) {
                    case "lost-incomplete":
                        return {};
                    case "unapproved":
                        return {goToProfile, moveToApproved, moveToArchive};
                    case "approved":
                        if (this.hasPermission("BLACKLIST_CAPTAIN"))
                            return {goToProfile, moveToArchive, blacklist};
                        else
                            return {goToProfile, moveToArchive};
                    case "incomplete":
                        return {goToProfile, answered, didntAnswer, moveToArchive};
                    case "blacklisted":
                        return {goToProfile, unBlacklist};
                    case "new_acq":
                        return {answered, didntAnswer};
                    default:
                        return {goToProfile, Unarchive: unArchive};
                }
            }
        }
    }
</script>

<style scoped>

</style>
